<template>
  <div style="padding:0 20px;">
    <div class="closeCurrntPage"  @click="closeCurrntPage">X关闭当前页</div>
    <div class="head">
      <el-button @click="oneKeyEnter(false)" size="mini" type="primary"><span style="font-size:12px;">一键录入打包数</span></el-button>
      <el-button @click="oneKeyClear(false)" size="mini" type="primary"><span style="font-size:12px;">一键清空打包数</span></el-button>
      <el-button @click="resetBoxNum" size="mini" style="background:#409eff;border-color:#409eff;float:right;"><span style="font-size:12px;color:#fff;">刷新</span></el-button>
    </div>
    <el-table
    v-loading="loading"
    :data="tableData"
    :row-class-name="tableRowClassName"
    border>
      <el-table-column
        type="index"
        label="序号"
      >
      </el-table-column>
      <el-table-column
        prop="created_at"
        label="推送日期"
      >
      </el-table-column>
      <el-table-column
        prop="main_number"
        label="主订单号"
      >
      </el-table-column>
      <el-table-column
        prop="serial_number"
        label="编号"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.serial_number">{{scope.row.serial_number.split('-').slice(3).join('-')}}</span>
          <!-- <span v-if="scope.row.express && isZhifaOrFactory">({{scope.row.express}})</span> -->
          <!-- <span>{{scope.row.serial_number.split('-').slice(3).join('-')}}</span> -->
        </template>
      </el-table-column>
      <el-table-column
        prop="weight"
        label="总重量(kg)"
        width="140px"
      >
      <template slot-scope="scope">
        <!-- <el-input-number v-if="scope.row.can_change"
        @focus="((val)=>{focusWeight(val,scope.row)})"
        :disabled="scope.row.isEditStatus && scope.row.can_change"
        v-model.trim="scope.row.weight" placeholder=""
        size="mini"
        :precision="2"
        :step="0.1"
        :controls="false"></el-input-number> -->
          <!-- <el-input v-if="scope.row.can_change"
            @focus="((val)=>{focusWeight(val,scope.row)})"
            @blur="((val)=>{changeCurrentWeight(val,scope.row,scope.$index)})"
            :disabled="scope.row.isEditStatus && scope.row.can_change"
            v-model.number="scope.row.weight" placeholder="" size="mini"></el-input> -->

          <el-input
            v-if="scope.row.can_change"
            @focus="((val)=>{focusWeight(val,scope.row)})"
            @change="((val)=>{changeCurrentWeight(val,scope.row,scope.$index)})"
            :disabled="scope.row.isEditStatus && scope.row.can_change"
            v-model="scope.row.weight" placeholder="" size="mini"></el-input>
          <el-input v-else :disabled="true" v-model="scope.row.weight" placeholder="" size="mini"></el-input>
        </template>
      </el-table-column>
      <el-table-column
        prop="ruigu_code"
        label="打包数"
        width="140px"
      >
        <template slot-scope="scope">
          <!-- <el-input-number
          v-if="scope.row.can_change"
          @change="((val)=>{changeCurrentBoxNum(val,scope.row)})"
          :disabled="scope.row.isEditStatus && scope.row.can_change"
          v-model.trim="scope.row.boxNumCopy" placeholder="" size="mini"
          :precision="0"
          :step="1"
          :controls="false"></el-input-number> -->
          <el-input
            v-if="scope.row.can_change"
            @change="((val)=>{changeCurrentBoxNum(val,scope.row,scope.$index)})"
            :disabled="scope.row.isEditStatus && scope.row.can_change"
            v-model="scope.row.boxNumCopy" placeholder="" size="mini"></el-input>
          <el-input v-else :disabled="true" v-model="scope.row.boxNumCopy" placeholder="" size="mini"></el-input>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="ruigu_code"
        label="操作"
        width="180px"
      >
        <template slot-scope="scope">
          <el-button @click="editBoxNum(scope.$index)" :disabled="!scope.row.can_change" type="text" class="editOrder">编辑打包数</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <div>
    </div>
    <div class="select-total-wrap">
      <div>合计</div>
      <div>主订单数量: <span>{{tableDataTotal.mainTotal}}</span></div>
      <div>总重量(kg): <span>{{tableDataTotal.weight}}</span></div>
      <div>打包数: <span>{{tableDataTotal.boxNum}}</span></div>
    </div>
    <div class="save">
      <el-button @click="saveBoxNum(false)" size="mini" type="primary"><span style="font-size:12px;">保存</span></el-button>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      :append-to-body="true"
      center
      width="500px">
      <span slot="title" style="color:#fff;">
        {{currentDialogType === dialogType[3] ? '提示':'确认'}}
      </span>
      <div v-if="currentDialogType === dialogType[0]" class="dialog-item">
        <p class="title content">一键录入</p>
        <p class="content gap-bottom">(打包数统一设置为1)</p>
        <div>
          <p class="content">
            注意：
          </p>
          <p class="content">
            1.若已有打包数，该原有数据不会被录入
          </p>
          <p class="content">
            2.若打包数非1，一键录入后可手工修改
          </p>
        </div>
      </div>
      <div v-if="currentDialogType === dialogType[1]" class="dialog-item">
        <p class="title content">一键清空</p>
        <p class="content gap-bottom">(<span class="red-color">打包数、重量、箱码</span>统一清空)</p>

        <div>
          <p class="content">
            注意：
          </p>
          <p class="content">
            1.一键清空后,可再次一键录入或者手工设置
          </p>
        </div>
      </div>
      <div v-if="currentDialogType === dialogType[2]" class="dialog-item">
        <p class="title content"><span class="red-color">订单打包数，是否均为1</span></p>
        <div>
          <p class="content">
            若不是，请手工修改打包数再保存，或者退出该页面后通过订单“编辑”修改打包数
          </p>
        </div>
      </div>
      <div v-if="currentDialogType === dialogType[3]">
        <p v-for="item in failedData" :key="item.id" class="content"><span style="color:#555;">主订单号</span><span style="font-weight:600;color:#555;">{{item.main_number}}：</span><span class="red-color">{{item.msg}}</span></p>
        <p>删除多余箱码，请到订单“编辑”操作</p>
      </div>
      <span slot="footer" class="dialog-footer" v-if="currentDialogType !== dialogType[3]">
        <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="dialogConfirm" size="mini">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {getOrderListForChangeBoxNum, saveBatchChangeBoxNum, clearBatchChangeBoxNum} from '@/models/orderModel'
const dialogType = ['onekeyEnter', 'onekeyClear', 'save', 'saveFaild']
export default {
  data () {
    return {
      isZhifaOrFactory: localStorage.getItem('shop_type') === '1' || localStorage.getItem('shop_type') === '2',
      dataIds: [],
      tableData: [],
      loading: false,
      tableDataTotal: {
        mainTotal: '',
        weight: '',
        boxNum: ''
      },
      dialogVisible: false,
      dialogType,
      failedData: [],
      failedRowIndex: [],
      currentDialogType: ''
    }
  },
  watch: {
    tableData: {
      handler: function (val) {
        let mainTotal = []
        let weightTotal = []
        let boxNumTotal = []
        if (val.length > 0) {
          val.forEach(item => {
            mainTotal.push(item.main_number)
            weightTotal.push(item.weight)
            boxNumTotal.push(item.boxNumCopy)
          })
          this.tableDataTotal.mainTotal = [...new Set([...mainTotal])].length
          this.tableDataTotal.weight = weightTotal.reduce((pre, curr) => {
            return Number(pre) + Number(curr)
          }, 0).toFixed(2)
          this.tableDataTotal.boxNum = boxNumTotal.reduce((pre, curr) => {
            return Number(pre) + Number(curr)
          }, 0).toFixed(0)
        }
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    this.$route.query.params.forEach(item => {
      this.dataIds.push(item.id)
    })
    this.getData()
  },
  methods: {
    getData () {
      this.loading = true
      getOrderListForChangeBoxNum({
        ids: JSON.stringify(this.dataIds)
      }).then(res => {
        let data = res.data
        console.log(data, 'data')
        data.forEach(item => {
          item.isEditStatus = false
          item.boxNumCopy = item.box_num
        })
        this.tableData = data
        this.loading = false
      })
    },
    tableRowClassName ({row, rowIndex}) {
      for (const i of this.failedRowIndex) {
        if (rowIndex === i) {
          return 'error-row'
        }
      }
      return ''
    },
    oneKeyEnter (val) {
      if (val) {
        this.tableData.forEach(item => {
          if (item.can_change) {
            if (!item.boxNumCopy) {
              item.boxNumCopy = 1
            }
          }
        })
        this.dialogVisible = false
      } else {
        this.currentDialogType = dialogType[0]
        this.dialogVisible = true
      }
    },
    oneKeyClear (val) {
      if (!val) {
        this.dialogVisible = true
        this.currentDialogType = dialogType[1]
      } else {
        let arr = []
        this.tableData.forEach(item => {
          if (item.can_change) {
            arr.push(item.id)
          }
        })
        if (arr.length > 0) {
          clearBatchChangeBoxNum({ids: JSON.stringify(arr)}).then(res => {
            if (res.code === 200) {
              let data = res.data
              let failed = data.failed
              // let succeed = data.succeed
              if (failed.length === 0) {
                this.$message.success('清空成功')
                this.failedRowIndex = []
                this.getData()
                this.dialogVisible = false
              } else {
                failed.forEach(item => {
                  let indexItem = -1
                  let fail = this.tableData.find((order, index) => {
                    indexItem = index
                    return item.id == order.id
                  })
                  item.main_number = fail.main_number
                  this.failedRowIndex.push(indexItem)
                })
                this.getData()
                this.failedData = failed
                this.currentDialogType = dialogType[3]
                this.dialogVisible = true
              }
            }
          })
        } else {
          this.$message.warning('无可清空打包数的订单')
          this.dialogVisible = false
        }
      }
    },
    editBoxNum (index) {
      this.tableData[index].isEditStatus = true
    },
    changeCurrentBoxNum (val, row, index) {
      if (!isNaN(Number(val))) {
        this.$set(this.tableData[index], 'boxNumCopy', parseInt(Number(val)))
      } else {
        this.$set(this.tableData[index], 'boxNumCopy', 0)
      }
      // // console.log(val, row, 'change')
      // if (!val) {
      //   // this.$message.warning('请填写打包数')
      // } else {
      //   if (val < row.box_num) {
      //     this.$message.warning('打包数小于当前值')
      //   }
      // }
    },
    changeCurrentWeight (val, row, index) {
      if (!isNaN(Number(val))) {
        let num = Number(val)
        this.$set(this.tableData[index], 'weight', num.toFixed(2))
      } else {
        this.$set(this.tableData[index], 'weight', '')
      }
      // console.log(val, row, 'change')
      // if (!val) {
      //   // this.$message.warning('请填写打包数')
      // } else {
      //   if (val < row.box_num) {
      //     this.$message.warning('打包数小于当前值')
      //   }
      // }
    },
    saveBoxNum (val) {
      this.failedRowIndex = []
      let arr = []
      this.tableData.forEach(item => {
        if (item.can_change) {
          arr.push(
            {'id': item.id, 'num': item.boxNumCopy, weight: item.weight}
          )
        }
      })
      if (val) {
        if (arr.length > 0) {
          let order = arr.find(item => {
            return !item.num || item.num == '0'
          })
          if (order) {
            this.$message('有打包数未填写或为0，请填写后保存')
          } else {
            saveBatchChangeBoxNum({item: JSON.stringify(arr)}).then(res => {
              if (res.code === 200) {
                let data = res.data
                let failed = data.failed
                // let succeed = data.succeed
                if (failed.length === 0) {
                  this.$message.success('设置成功')
                  this.failedRowIndex = []
                  this.getData()
                  this.dialogVisible = false
                } else {
                  failed.forEach(item => {
                    let indexItem = -1
                    let fail = this.tableData.find((order, index) => {
                      indexItem = index
                      return item.id == order.id
                    })
                    item.main_number = fail.main_number
                    this.failedRowIndex.push(indexItem)
                  })
                  this.getData()
                  this.failedData = failed
                  this.currentDialogType = dialogType[3]
                  this.dialogVisible = true
                }
              }
            })
          }
        }
      } else {
        let box = this.tableData.find(item => {
          return item.boxNumCopy != '1'
        })
        if (!box) {
          this.currentDialogType = dialogType[2]
          this.dialogVisible = true
        } else {
          this.saveBoxNum(true)
        }
      }
    },
    resetBoxNum () {
      this.failedRowIndex = []
      this.getData()
    },
    closeCurrntPage () {
      this.failedRowIndex = []
      if (localStorage.getItem("is_jgj") === "1") {
              // 为紧固件
        this.$router.push("/order/manageFastener");
      } else {
        this.$router.push("/order/manage");
      }
    },
    dialogConfirm () {
      if (this.currentDialogType === dialogType[0]) {
        this.oneKeyEnter(true)
      }
      if (this.currentDialogType === dialogType[1]) {
        this.oneKeyClear(true)
      }
      if (this.currentDialogType === dialogType[2]) {
        this.saveBoxNum(true)
      }
      if (this.currentDialogType === dialogType[3]) {

      }
    },
    focusWeight (e, row) {
      row.weight = ' '
    }
  }
}
</script>

<style lang="scss" scoped>
.head{
  margin: 20px 0;
  span{
    display: inline-block;
    // margin-right: 10px;
  }
}
.select-total-wrap{
  font-weight: bold;
  margin-top: 20px;
  display: flex;
  padding-bottom: 10px;
  border-bottom: 1px solid #666;
  div{
    margin-right: 20px;
    span{
      color: blue;
    }
  }
}
.closeCurrntPage {
  border-radius: 10px;
  border: 1px solid #dcdfe6;
  cursor: pointer;
  font-size: 14px;
  position: fixed;
  right: 16px;
  line-height: 20px;
  top: 53px;
  text-align: center;
  width: 94px;
  height: 20px;
  border-radius: 5px;
  background-color: white;
}
.editOrder {
  color: red;
  font-size: 12px;
}
.red-color{
  color: red;
}
.save{
  text-align: center;
  margin-top: 25px;
}
.dialog-item{
  &>p{
    text-align: center;
    font-weight: 600;
  }
}
.title{
  font-size: 20px;
}
.content{
  padding: 2px;
  margin: 0;
}
.gap-bottom{
  margin-bottom: 25px;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/quick-set-box-num.vue